/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersSubscriptionsRegisterPut500Response model module.
 * @module model/CustomersSubscriptionsRegisterPut500Response
 * @version 1.0.0
 */
class CustomersSubscriptionsRegisterPut500Response {
    /**
     * Constructs a new <code>CustomersSubscriptionsRegisterPut500Response</code>.
     * @alias module:model/CustomersSubscriptionsRegisterPut500Response
     */
    constructor() { 
        
        CustomersSubscriptionsRegisterPut500Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersSubscriptionsRegisterPut500Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersSubscriptionsRegisterPut500Response} obj Optional instance to populate.
     * @return {module:model/CustomersSubscriptionsRegisterPut500Response} The populated <code>CustomersSubscriptionsRegisterPut500Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersSubscriptionsRegisterPut500Response();

            if (data.hasOwnProperty('error')) {
                obj['error'] = ApiClient.convertToType(data['error'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersSubscriptionsRegisterPut500Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersSubscriptionsRegisterPut500Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['error'] && !(typeof data['error'] === 'string' || data['error'] instanceof String)) {
            throw new Error("Expected the field `error` to be a primitive type in the JSON string but got " + data['error']);
        }

        return true;
    }


}



/**
 * @member {String} error
 */
CustomersSubscriptionsRegisterPut500Response.prototype['error'] = undefined;






export default CustomersSubscriptionsRegisterPut500Response;

